"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentsLibraries = exports.whitelist = void 0;
/**
 * This is a temp source of truth until a better alternative is supplied via DevCenter or something similar
 */
exports.whitelist = [
    {
        artifactId: 'editor-elements',
        url: 'https://static.parastorage.com/services/editor-elements/1.665.0',
        manifestName: 'library-manifest',
    },
];
/**
 * Will return list of components libraries with actual urls to each one of them.
 * In case when "serviceTopology" is not provided a whitelist of libraries
 * without urls will be returned
 */
exports.getComponentsLibraries = function (serviceTopology) {
    if (!serviceTopology) {
        return exports.whitelist;
    }
    return exports.whitelist.reduce(function (acc, lib) {
        var artifactId = lib.artifactId;
        var libraryEntryInTopology = serviceTopology[artifactId] ||
            serviceTopology.scriptsLocationMap[artifactId];
        acc.push(__assign(__assign({}, lib), { url: libraryEntryInTopology
                ? libraryEntryInTopology
                : lib.url }));
        return acc;
    }, []);
};
//# sourceMappingURL=getComponentsLibraries.js.map